import { useContext, KeyboardEventHandler } from 'react'
import * as React from 'react'
import { WeightNamesMap, WeightValue } from './util'

import { AlmanacEditorStateContext } from 'stores/EditorState'

import { ReactComponent as DownIcon } from 'assets/icons/chevron-down--small__16.svg'
import { ReactComponent as UpIcon } from 'assets/icons/chevron-up--small__16.svg'

import Styles from './FontWeight.module.scss'
import { observer } from 'mobx-react-lite'

interface Props {
  inputRef: React.RefObject<HTMLInputElement>
  handleFontWeightChange: React.ChangeEventHandler
  handleInputFocus: React.FocusEventHandler
  handleKeyDown: KeyboardEventHandler
  handleChevronClick: (e: React.MouseEvent<HTMLDivElement>) => void
  fontWeightInput: any
  isOpen: boolean
}

export const FontWeightDisplay = observer(function FontWeightDisplay({
  inputRef,
  handleFontWeightChange,
  handleInputFocus,
  handleKeyDown,
  handleChevronClick,
  isOpen,
}: Props) {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { fontWeight } = useContext(AlmanacEditorStateContext)!

  const fontWeightValue = fontWeight ? WeightNamesMap[fontWeight as WeightValue] : ''

  return (
    <>
      <input
        className={Styles.input}
        data-testid="fontWeight-input"
        ref={inputRef}
        value={fontWeightValue ?? ''}
        onChange={handleFontWeightChange}
        onFocus={handleInputFocus}
        onKeyDown={handleKeyDown}
      />
      <div className={Styles.chevron} onClick={handleChevronClick}>
        {isOpen ? <UpIcon /> : <DownIcon />}
      </div>
    </>
  )
})
